import React from 'react';
import {connect} from 'react-redux';
import Text from './Text';
import queryString from 'query-string';
import showCallbackButton from '../utilities/showCallbackButton';
import isDisabledPaketShopButton from '../utilities/isDisabledPaketShopButton';

const joinCallbackUrlAndShopInfos = (url, shop) => {
  const parser = document.createElement('a');
  const query = queryString.parse(location.search);

  const splitedCbUrl = decodeURIComponent(url).split('?');

  // Base Url
  parser.href = splitedCbUrl[0];

  // Callback params
  const cbParams = queryString.parse(splitedCbUrl[1]);
  const shopParams = {
    // It may be that the house number is not available.
    street: shop.street + (shop.houseNumber ? ' ' + shop.houseNumber : ''),
    city: shop.city,
    zip: shop.zip,
    name: shop.description || shop.name,
    shopid: shop.parcelShopNumber,
    cb_par1: query.cb_par1,
    cb_par2: query.cb_par2
  };


  parser.search = queryString.stringify(
    Object.assign(cbParams, shopParams)
  );

  return parser.href;
};

const legacyCallbackHandler = (baseUrl, shop, isDisabled) => {

  if (isDisabled) {
      return;
  }
  const url = joinCallbackUrlAndShopInfos(baseUrl, shop);
  const frame = document.createElement('iframe');

  frame.id = 'proxyframe';
  frame.name = 'proxyframe';
  frame.src = url;
  frame.style.display = 'none';
  document.body.appendChild(frame);
};

const CallbackButton = ({url, shop, show, useLegacyHandler, isDisabled}) => {

  if (show === 'wrong-code') {
    return (
      <Text id="callback-button.unavailable" className='text-danger'/>
    );
  }

  if (show === true) {

    if (shop.isPaketParcelLock) {
        return (
          <div onClick={(event) => { event.stopPropagation; legacyCallbackHandler(url, shop) }} className={`btn btn-primary btn-sm ${isDisabled ? 'disabled' : ''}`}>
            <Text id='callback-button.paketParcelLock.text'/>
          </div>
        );
    }

    if (useLegacyHandler) {
      return (
        <div onClick={(event) => { event.stopPropagation; legacyCallbackHandler(url, shop, isDisabled) }} className={`btn btn-primary btn-sm ${isDisabled ? 'disabled' : ''}`}>
          <Text id='callback-button.text'/>
        </div>
      );
    }

    return (
      <a href={`${isDisabled ? '#0' : joinCallbackUrlAndShopInfos(url, shop)}`} className={`btn btn-primary btn-sm ${isDisabled ? 'disabled' : ''}`}>
        <Text id='callback-button.text'/>
      </a>
    );
  }

  return null;
};

const mapStateToProps = ({config}, {shop}) => ({
  url: config.callbackUrl,
  show: (()=> {
    return showCallbackButton(config, shop);
  })(),
  useLegacyHandler: config.cb_method !== 'link',
  isDisabled: (()=> {
    return isDisabledPaketShopButton(shop);
  })()
});

export default connect(mapStateToProps)(CallbackButton);
